module.exports = __webpack_public_path__ + "img/3g2.eb21dbd8.svg";